Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapOpenMarkerReducer;

var _constants = require('../constants');

function mapOpenMarkerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _constants.SET_MAP_OPEN_MARKERS:
      return action.openMarkers;

    default:
      return state;
  }
}